import { processSteps } from "../../../mocks/magazine";

export default function HowItWorks() {
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#C41E3A] text-xs tracking-[0.3em] uppercase font-semibold mb-4">Simple, Start to Finish</p>
          <h2 className="text-4xl md:text-5xl font-serif font-light text-[#2B2B2B] leading-tight">
            Concept to Cover,<br />In a Matter of Weeks
          </h2>
          <p className="text-[#6B6B6B] text-base mt-4 max-w-lg mx-auto">
            Four steps. Zero headaches. One genuinely exciting thing in your mailbox.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {processSteps.map((step, index) => (
            <div
              key={step.step}
              className="relative bg-white rounded-2xl p-8 hover:shadow-lg transition-all duration-300 group"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Step Number */}
              <div className="flex items-center gap-3 mb-6">
                <span className="text-[#C41E3A] font-serif text-4xl font-light leading-none opacity-40">{step.step}</span>
                <div className="h-px flex-1 bg-[#E8E0D0]" />
              </div>

              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F5F1E8] mb-5 group-hover:bg-[#C41E3A] transition-colors duration-300">
                <span className="w-6 h-6 flex items-center justify-center text-[#C41E3A] group-hover:text-white transition-colors duration-300 text-xl">
                  <i className={step.icon} />
                </span>
              </div>

              <h3 className="font-serif text-xl text-[#2B2B2B] mb-3">{step.title}</h3>
              <p className="text-[#6B6B6B] text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
